import React, {useState} from "react";
import "./header.css";
import {Grid, Image, Button, Message, Form } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {data, useWindowWidth} from "artcode-tool";
import NumberFormat from 'react-number-format';
const axios = require('axios');

function Header(){

    const [name, setName] = useState("");
    const [mail, setMail] = useState("");
    const [cellphone, setCellphone] = useState("");
    const [error, setError] = useState("no");
    const [loading, setLoading] = useState(false);

    const [errorFormName, setErrorFormName] = useState(false);
    const [errorFormMail, setErrorFormMail] = useState(false);
    const [errorFormCellphone, setErrorFormCellphone] = useState(false);
    
    let width = useWindowWidth();

    function update_status(loading_process, error_process, error_name, error_mail, error_cellphone){
        setLoading(loading_process);
        setError(error_process);
        setErrorFormName(error_name);
        setErrorFormMail(error_mail);
        setErrorFormCellphone(error_cellphone);
    }

    function sendMail(){
        let error_name = false;
        let error_mail = false;
        let error_cellphone = false;
        let error_process = "error";
        let loading_process = false;
        let cellphone_number = cellphone.replace(/[^0-9]/g,'');
        if(name === "") error_name = true; else error_name = false;
        if(mail === "") error_mail = true; else error_mail = false;
        if(cellphone_number === "" || cellphone_number.length <= 10) error_cellphone = true; else error_cellphone = false;

        if(!error_name && !error_mail && !error_cellphone){
            loading_process = true;
            const dataSend = JSON.stringify({
                "name": name,
                "email": mail,
                "cellphone": cellphone
            })

            axios.post('https://artefield.com.br/_api/contact.php/', dataSend)
              .then(function (response) {
    
                if(response.data.send === "true"){
                    error_process = "success";
                    setName(""); setMail(""); setCellphone("");
                    
                }  else {
                    error_process = "warning";
                }
                loading_process = false;
                update_status(loading_process, error_process, error_name, error_mail, error_cellphone);
        
              })
              .catch(function (error) {
                console.log(error);
              });

        } else {
            loading_process = false;
            error_process = "error";
        }
        
        update_status(loading_process, error_process, error_name, error_mail, error_cellphone);
        
    }

    return (
        
        <header className="content-header" id="contato">
            <div className="content-main">
                <div className="circle circle-blue"></div>
                <div className="main-logotipo">
                    <Image src={require("./logotipo-artefield.png")}  title="Logotipo Artefield"  alt="Logotipo Artefield"/>
                </div>
            </div>
            <Grid className="content-header">
                <Grid.Row columns={(width < data.widthResponsive)?1:2}>
                    <Grid.Column>
                        <h1>Artefield, comunicação muito além da visual</h1>
                        <h2>Com a artefield, você terá em mãos todo o cuidado necessário para a confecção da sua fachada, envelopamento, letras caixas, ou qualquer impressão digital que pretenda ter em seu negócio. Garantimos a qualidade necessária de nossos produtos e satisfação necessária dos nossos clientes. Abaixo, confira grandes trabalhos realizados pela nossa equipe, e sinta-se à vontade para fazer um orçamento. Criando seu orçamento ao lado, você já garante seus 5% de desconto. Avalie seu projeto conosco agora mesmo!</h2>
                    </Grid.Column>
                    <Grid.Column>
                        <Form loading={(loading?true:false)} error={(error === "error") ? true:false}  success={(error === "success") ? true:false}  warning={(error === "warning") ? true:false}>
                            <h3>Preencha o formulário e ganhe 5% de desconto</h3>
                            <Form.Input placeholder='Seu nome completo' value={name} onChange={e => setName(e.target.value)} error={errorFormName?true:false}/>
                            <Form.Input placeholder='E-mail' value={mail} onChange={e => setMail(e.target.value)} error={errorFormMail?true:false}/>
                            <Form.Input placeholder='Celular' value={cellphone} onChange={e => setMail(e.target.value)} error={errorFormCellphone?true:false}><NumberFormat className="ui-input" placeholder='Celular' format="(##) #####-####" mask="_" onChange={e => setCellphone(e.target.value)}/></Form.Input>
                            <Message warning header='Não foi possível enviar o e-mail' content='ocorreu um erro na hora de enviar seu e-mail. Por favor, tente novamente mais tarde'/>
                            <Message error header='Preencha todos os campos' content='Preencha os campos obrigatórios para enviar'/>
                            <Message success header='Email enviado' content='O seu orçamento foi enviado com sucesso! Em breve, entraremos em contato para entendermos melhor o seu projeto.'/>
                            <Button className="artefield-button" onClick={sendMail}>Submit</Button>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </header>
    );
}

export default (Header);